$(document).ready(() => {
  // Change background Color
  const $body = $('body');
  $body.css('background-color', '#f5f6f7');

  // Remove header
  const $header = $('header');
  $header.remove();

  // Remove footer
  const $footer = $('footer');
  $footer.remove();

  // Remove footer border
  const $footerHr = $('.footer-hr');
  $footerHr.remove();

  // Not totally sure what this is, maybe some spacing? Remove anyway
  const $preFooter = $('.pre-footer');
  $preFooter.remove();

  // Remove search bar
  const $searchBar = $('.menu-search');
  $searchBar.remove();

  // Remove menu bar
  const $topicsBar = $('.topics');
  $topicsBar.remove();

  // Remove some dashes at the top of the page
  const $dashes = $('.hide-small show-large');
  $dashes.remove();

  // Modify page-wrapper padding-top
  const $pageWrapper = $('.page-wrapper');
  $pageWrapper.css('padding-top', '50px');

  // Modify baseline-footer text-align
  const $baselineFooterWrapper = $('.baseline-footer-wrapper');
  $baselineFooterWrapper.css('text-align', 'center');
});
